import { Form, FormFieldType } from "@/forms/Form";

export class AppointmentMapFilterForm extends Form {
  protected definition = {
    startDate: { required: true, type: FormFieldType.Date },
    endDate: { required: true, type: FormFieldType.Date }
  };
}
